import { buttonTheme } from './button';
import { textField } from './textField';
// import { typography } from './typography';
import { cardTheme } from './cards';
import { shadows } from './shadows';
import { table } from './table';
import { containerTheme } from './container';
import { linkTheme } from './link';
import { selectInput } from './selectInput';
import { sliders } from './slider';
import { iranSans } from './typography';
import { fontTheme } from './font';

export const appTheme = {
  components: {
    ...buttonTheme,
    ...textField,
    ...selectInput,
    ...cardTheme,
    ...table,
    ...containerTheme,
    ...linkTheme,
    ...sliders,
    ...fontTheme,
  },
  typography: {
    fontFamily: iranSans.style.fontFamily,
    // fontWeightThin: 100,
    // fontWeightLight: 300,
    // fontWeightRegular: 400,
    // fontWeightMedium: 500,
    // fontWeightBold: 700,
    // fontWeightBlack: 900,
    h1: {
      fontWeight: 700,
      fontSize: '48px',
      lineHeight: '1.2em',
    },
    h2: {
      fontWeight: 700,
      fontSize: '28px',
      letterSpacing: '-.75px',
      lineHeight: '1.2em',
    },
    h3: {
      fontWeight: 700,
      fontSize: '24px',
      letterSpacing: '-.75px',
      lineHeight: '1.2em',
    },
    h4: {
      fontWeight: 700,
      fontSize: '20px',
      letterSpacing: '-.75px',
      lineHeight: '1.2em',
    },
    h5: {
      fontWeight: 500,
      lineHeight: '1.2em',
    },
    body1: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '1.3em',
    },
    body2: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '1.3em',
    },
    button: {
      fontWeight: 500,
      fontSize: '14px',
    },
  },
  // shadows,
  shape: {
    borderRadius: 4,
    image: {
      borderRadius: 15,
    },
  },
};
